import React from "react";
import Dropdown from "../../Atom/Dropdown";
const InsertVariables = ({ options, onSelect, disabled = false }) => {
	return (
		<div className="inline-block" style={{ width: "200px" }}>
			<Dropdown
				options={options}
				onChange={onSelect}
				value={null}
				placeholder={"Insert Variables"}
				disabled={disabled}
			/>
		</div>
	);
};

export default InsertVariables;
